var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-wrap home-content-wrap"},[_c('section-title',[_c('template',{slot:"title"},[_vm._v("Статистика")])],2),_vm._v(" "),_c('div',{staticClass:"page-statistics-content"},[_c('goal-survey-statistics')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }